import { useMemo } from "react";

import { type AttributionFilter, type MetadataCloud } from "@doitintl/cmp-models";
import { Stack, Typography } from "@mui/material";

import { FilterDialogContainer } from "../../Components/Dialogs/CloudAnalytics/FilterDialogContainer";
import { getModeLabel } from "../../Components/Dialogs/CloudAnalytics/utils";
import { type MetadataOption } from "../../types/Report";
import { AttributionChips } from "./AttributionChips";

type Props = {
  dimension: MetadataOption | null;
  value: AttributionFilter;
  onChange: (value: AttributionFilter) => void;
  cloudProviders?: MetadataCloud[];
  disableRegexpFilter?: boolean;
};

export const AttributeSelector = ({
  dimension,
  value,
  onChange,
  cloudProviders,
  disableRegexpFilter = false,
}: Props) => {
  const syncedDimension = useMemo(() => {
    if (!dimension) {
      return null;
    }

    const synced = { ...dimension };
    if (disableRegexpFilter) {
      synced.data.disableRegexpFilter = disableRegexpFilter;
    }

    synced._filter = value.values ?? [];
    synced.data.nullFallback = null;

    if (value.inverse !== undefined && dimension._inverse !== value.inverse) {
      synced._inverse = value.inverse;
    }

    return synced;
  }, [dimension, value.inverse, disableRegexpFilter, value.values]);

  if (!syncedDimension) {
    return null;
  }
  return (
    <Stack spacing={3} direction="row" alignItems="center">
      <FilterDialogContainer
        onSave={(filter) => {
          onChange(filter);
        }}
        dimension={syncedDimension}
        cloudProviders={cloudProviders}
      />
      <Typography variant="subtitle1" fontWeight={500}>
        {getModeLabel(value.mode, value.inverse)}
      </Typography>
      <AttributionChips filter={value} />
    </Stack>
  );
};
